import {
  Component,
  computed,
  EventEmitter,
  input,
  model,
  Output,
} from "@angular/core";
import { ChipsComponent } from "../../modules/chips/chips.component";
import { ChipState } from "../../enums/chip-state.enum";

/**
 * Bouton « déplier / replier » (une puce + chevron). ⚠ 28/09/2026 (a11y) : la puce porte
 * `aria-expanded` (elle ne disait pas son état), RECOPIÉ sur l'hôte — l'élément du `data-testid`,
 * que les POM relisent (`btn-workshop-missed-toggle`), comme `aria-pressed` de `vl-chips`. Opt-in :
 * `state` (couleur de la puce, ex. `error-soft` pour « N manqué(s) ») à la place de celle de `mode`.
 */
@Component({
  selector: "vl-expand-button",
  standalone: true,
  imports: [ChipsComponent],
  templateUrl: "./expand-button.component.html",
  styleUrl: "./expand-button.component.scss",
  host: {
    "[attr.aria-expanded]": "expanded() ? 'true' : 'false'",
  },
})
export class ExpandButtonComponent {
  expanded = model<boolean>(false);
  size = input<"small" | "big">("big");
  mode = input<"dark" | "normal">("normal");
  label? = input<string>();
  /** Couleur de la puce (`ChipState`) ; absent → celle de `mode`. */
  state = input<ChipState | null>(null);

  expandedState = computed<ChipState>(() => {
    return this.state() ?? (this.mode() === "normal" ? "enabled" : "reverse");
  });
  @Output() expand = new EventEmitter<boolean>();
}
